import { render, staticRenderFns } from "./UpdateUserSettings.vue?vue&type=template&id=475db142&"
import script from "./UpdateUserSettings.vue?vue&type=script&lang=js&"
export * from "./UpdateUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports